import { Checkbox, Col, Row } from 'antd'
import Button from 'components/Button'
import objects from 'components/Images/OBJECTS.png'
import duplicate from 'components/Images/duplicate.png'
import publish from 'components/Images/publish.png'
import {
  deleteEvent,
  duplicateEvent,
  editEvent,
  eventCreation,
} from 'modules/Events/actions'
import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import SuccessMessage from 'utils/SuccessMessage'
import PinIcon from '../../../../../components/icons/JobRoleIcons/PinIcon'
import {
  ButtonContainer,
  ButtonDiv,
  ButtonShowStudent,
  Category,
  Container1,
  EventData,
  EventData1,
  EventData4,
  EventDatecard,
  EventLabel,
  EventName,
  MainDiv,
  ModalCheckbox,
  ModalContent,
  ModalOverlay,
  ModalText,
  ModalText1,
  Right,
  ShortListModalImg,
  ShowLessText,
  ShowMoreText,
  Size,
  StyledButton1,
  StyledButton2,
  StyledDivision,
  Uploaders,
  VerticalDivider,
} from './style'

const Modal = ({ onClose, children }) => {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>{children}</ModalContent>
    </ModalOverlay>
  )
}

const PreviewBox = ({
  elgibileCount,
  eventDetails,
  onClose,
  isEditing,
  isPublish,
  open,
  cropImage,
  setRenderState,
}) => {
  const params = useParams()

  const categoryStyles = {
    OTHERS: {
      borderColor: '#001B48',
      backgroundColor: 'rgba(0, 27, 72, 0.2)',
      textColor: 'White',
    },
    PRE_PLACEMENT_TALK: {
      borderColor: '#97CADB',
      backgroundColor: 'rgba(151, 202, 219, 0.2)',
      textColor: 'Black',
    },
    SEMINAR: {
      borderColor: '#B5A3F7',
      backgroundColor: 'rgba(181, 163, 247, 0.2)',
      textColor: 'Black',
    },
    WEBINAR: {
      borderColor: '#E1A7BA',
      backgroundColor: 'rgba(225, 167, 186, 0.2)',
      textColor: 'Black',
    },
    LECTURE: {
      borderColor: '#8D6AA0',
      backgroundColor: 'rgba(141, 106, 160, 0.2)',
      textColor: 'White',
    },
    CONFERENCE: {
      borderColor: '#F29F05',
      backgroundColor: 'rgba(242, 159, 5, 0.2)',
      textColor: 'Black',
    },
    PANEL_DISCUSSION: {
      borderColor: '#F25C05',
      backgroundColor: 'rgba(242, 92, 5, 0.2)',
      textColor: 'Black',
    },
    HACKATHON: {
      borderColor: '#31AAB5',
      backgroundColor: 'rgba(49, 170, 181, 0.2)',
      textColor: 'Black',
    },
    WORKSHOP: {
      borderColor: '#72B06F',
      backgroundColor: 'rgba(114, 176, 111, 0.2)',
      textColor: 'Black',
    },
    CAMPAIGN: {
      borderColor: '#4C1D91',
      backgroundColor: 'rgba(76, 29, 145, 0.2)',
      textColor: 'White',
    },
    SPORTS_EVENT: {
      borderColor: '#13593F',
      backgroundColor: 'rgba(19, 89, 63, 0.2)',
      textColor: 'White',
    },
    ACTIVITY_EVENT: {
      borderColor: '#02457A',
      backgroundColor: 'rgba(2, 69, 122, 0.2)',
      textColor: 'White',
    },
    EXHIBITION: {
      borderColor: '#595F33',
      backgroundColor: 'rgba(89, 95, 51, 0.2)',
      textColor: 'White',
    },
  }
  const typeLabels = {
    OTHERS: 'Others',
    PRE_PLACEMENT_TALK: 'Pre Placement Talk',
    SEMINAR: 'Seminar',
    WEBINAR: 'Webinar',
    LECTURE: 'Lecture',
    CONFERENCE: 'Conference',
    PANEL_DISCUSSION: 'Panel Discussion',
    HACKATHON: 'Hackathon',
    WORKSHOP: 'Workshop',
    CAMPAIGN: 'Campaign',
    SPORTS_EVENT: 'Sports Event',
    ACTIVITY_EVENT: 'Activity / Event',
    EXHIBITION: 'Exhibition',
  }
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const categoryStyle = categoryStyles[eventDetails?.category] || {
    borderColor: '#d8ddff',
    backgroundColor: 'white',
    textColor: 'black',
  }

  const [isModalVisible, setIsModalVisible] = useState(false)
  const [modalContent, setModalContent] = useState({ image: '', text: '' })
  const handleDeleteClick = () => {
    setRenderState(true)
    setModalContent({
      image: 'deleteImage',
      text: 'Are you sure you want to delete this event?',
      actionType: 'delete',
    })
    setIsModalVisible(true)
  }

  const handleDuplicateClick = () => {
    setRenderState(true)

    setModalContent({
      image: 'duplicateImage',
      text: 'Are you sure you want to duplicate this event?',
      actionType: 'duplicate',
    })
    setIsModalVisible(true)
  }

  const handlePublishClick = () => {
    setModalContent({
      image: 'publishImage',
      text: 'Do you want to publish and send this event?',
      actionType: 'publish',
    })
    setIsModalVisible(true)
  }

  const handleCloseModal = () => {
    setIsModalVisible(false)
  }

  const [loading, setLoading] = useState(false)

  const handleConfirmAction = async () => {
    setLoading(true)
    if (modalContent?.actionType === 'duplicate') {
      setRenderState(true)
      let data = await dispatch(duplicateEvent({ eventId: eventDetails?.id }))

      if (data?.status >= 200 && data?.status <= 300) {
        SuccessMessage('The duplicated Event is saved in drafts')
        setIsModalVisible(false)
        onClose()
      }
    }

    if (modalContent?.actionType === 'delete') {
      setRenderState(true)
      let data = await dispatch(deleteEvent({ eventId: eventDetails?.id }))
      if (data?.status > 200 && data?.status < 300) {
        SuccessMessage('Event Deleted Successfully')
        setIsModalVisible(false)
        onClose()
      }
    }

    if (modalContent?.actionType === 'publish') {
      const degreeDataList = payLoadFormatting(eventDetails?.eventDegreeMapping)
      const prePayDegree = degreeDataList?.map(degree => {
        const { specializations, ...rest } = degree
        return {
          ...rest,
          specialisationId: specializations,
        }
      })
      let payLoad = {
        ...eventDetails,
        status: 1,
        eventDegreeMapping: prePayDegree,
      }
      if (cropImage) {
        payLoad.banner = cropImage
      }
      if (payLoad.banner === null) {
        delete payLoad.banner
      }

      if (!isEditing) {
        let res = await dispatch(eventCreation(payLoad))
        if (res?.status > 200 && res?.status < 300) {
          SuccessMessage('Event Published Successfully')
          setIsModalVisible(false)
          onClose()
          navigate('/events')
        }
      } else {
        let res = await dispatch(editEvent(payLoad, params?.eventID))
        if (res?.status > 200 && res?.status < 300) {
          SuccessMessage('Event Saved Successfully')
          setIsModalVisible(false)
          onClose()
          navigate('/events')
        }
      }
    }
    setLoading(false)
  }
  useEffect(() => {}, [eventDetails])
  const payLoadFormatting = degrees => {
    return degrees?.flatMap(degree => {
      if (degree?.streams?.length === 0) {
        return {
          degreeId: degree?.degreeId,
          degreeType:
            degree?.type === 'P.G.DIPLOMA'
              ? 'PG_DIPLOMA'
              : degree?.type === 'P_G_DIPLOMA'
              ? 'PG_DIPLOMA'
              : degree?.type,
          isDegreeOnly: true,
        }
      }

      return degree?.streams.map(stream => {
        return {
          degreeId: degree?.degreeId,
          degreeType:
            degree?.type === 'P.G.DIPLOMA'
              ? 'PG_DIPLOMA'
              : degree?.type === 'P_G_DIPLOMA'
              ? 'PG_DIPLOMA'
              : degree?.type,
          streamId: stream?.streamId,
          specializations: stream?.specializations.map(spec => spec?.id),
        }
      })
    })
  }
  const formatDateTime = dateString => {
    return moment(dateString).format('DD/MM/yyyy')
  }

  const formatYears = years => {
    if (typeof years === 'string') {
      return years.replace(/(\d{4})(?=\d)/g, '$1,')
    }
    if (Array.isArray(years)) {
      return years.join(', ')
    }
    return years
  }

  const formatTime = time => {
    let timeSplit

    if (moment.isMoment(time)) {
      timeSplit = time.format('HH:mm')
    } else if (typeof time === 'string' && time?.includes(':')) {
      timeSplit = time
    } else {
      console.error('Invalid time format')
      return ''
    }

    const [hour, minute] = timeSplit?.split(':') || []
    const hourNumber = parseInt(hour, 10)
    const period = hourNumber >= 12 ? 'PM' : 'AM'
    const formattedHour = hourNumber % 12 || 12
    return `${formattedHour}:${minute} ${period}`
  }

  const downloadFileLocal = async file => {
    try {
      const response = await fetch(file.url)
      if (!response.ok) {
        throw new Error('Failed to download file')
      }
      const blob = await response.blob()
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = file.name
      document.body.appendChild(a)
      a.click()
      URL.revokeObjectURL(url)
      document.body.removeChild(a)
    } catch (error) {
      console.error('Error downloading file:', error)
    }
  }

  const hasTime = eventDetails?.startTime && eventDetails?.endTime

  //   const [showAllDegrees, setShowAllDegrees] = useState(false)
  //  const initialDegreesToShow = 5
  // const degreesToDisplay = Array.isArray(eventDetails.eventDegreeMapping)
  //   ? showAllDegrees
  //     ? eventDetails.eventDegreeMapping
  //     : eventDetails.eventDegreeMapping.slice(0, initialDegreesToShow)
  //   : []

  const degreeDataList =
    eventDetails?.eventDegreeMapping != null &&
    Object?.entries(eventDetails?.eventDegreeMapping).flatMap(
      ([degreeType, degrees]) => {
        if (!Array.isArray(degrees) || degrees.length === 0) {
          return []
        }
        return degrees.map(degree => ({
          shortForm: degree.shortForm,
          streams: Array.isArray(degree.streams)
            ? degree.streams.map(stream => ({
                name: stream.name,
                specialisations: Array.isArray(stream.specialisations)
                  ? stream.specialisations.map(spec => spec.name)
                  : [],
              }))
            : [],
        }))
      }
    )
  const degreeShortFormWithStreams =
    degreeDataList?.length > 0 &&
    degreeDataList
      .flatMap(degree => {
        if (degree.streams.length > 0) {
          return degree.streams.flatMap(stream => {
            if (stream.specialisations.length > 0) {
              return stream.specialisations.map(spec => {
                return `${degree.shortForm} - ${stream.name} (${spec})`
              })
            } else if (stream.name) {
              return [`${degree.shortForm} - ${stream.name}`]
            } else {
              return [`${degree.shortForm}`]
            }
          })
        } else {
          return [`${degree.shortForm}`]
        }
      })
      .join('\n')

  const renderContent = () => {
    return (
      <EventData4>
        {eventDetails.eventDegreeMapping &&
        eventDetails.eventDegreeMapping.length > 0 ? (
          eventDetails.eventDegreeMapping.map(degree => {
            const hasDepartments = degree.streams?.length > 0
            return (
              <React.Fragment key={degree.degreeId}>
                {hasDepartments ? (
                  degree.streams.length > 0 ? (
                    degree.streams.map(dep =>
                      dep.specializations && dep.specializations.length > 0 ? (
                        dep.specializations.map(spec => (
                          <div
                            key={`${degree.degreeId}-${dep.streamId}-${spec.specialisationId}`}
                          >
                            {`${degree.shortForm} - ${dep.name} (${spec.name})`}
                          </div>
                        ))
                      ) : (
                        <div key={`${degree.degreeId}-${dep.streamId}`}>
                          {`${degree.shortForm} - ${dep.name}`}
                        </div>
                      )
                    )
                  ) : (
                    <div key={degree.degreeId}>{degree.shortForm}</div>
                  )
                ) : (
                  <div key={degree.degreeId}>{degree.shortForm}</div>
                )}
              </React.Fragment>
            )
          })
        ) : (
          <div>
            {degreeShortFormWithStreams?.length > 0 &&
              degreeShortFormWithStreams.split('\n').map((line, index) => (
                <div key={index + 'degree'} className="degree-line">
                  {line}
                </div>
              ))}
          </div>
        )}
        - {formatYears(eventDetails.yearOfPassing)}
      </EventData4>
    )
  }

  const [expanded, setExpanded] = useState(true)

  const toggleExpanded = () => {
    setExpanded(!expanded)
  }

  const contentHeight = useRef(null)
  useEffect(() => {
    if (contentHeight?.current && contentHeight?.current?.clientHeight > 250) {
      setExpanded(false)
    }
  }, [])

  const convertBytesToKB = bytes => {
    return (bytes / 1024).toFixed(2)
  }

  const truncateName = (name, maxLength) => {
    if (name.length > maxLength) {
      return name.substring(0, maxLength) + '...'
    }
    return name
  }

  return (
    <>
      <div>
        <MainDiv
          borderColor={categoryStyle.borderColor}
          backgroundColor={categoryStyle.backgroundColor}
          color={categoryStyle.textColor}
        >
          <StyledDivision>
            <Row>
              <Col span={eventDetails?.status === 1 ? 14 : 22}>
                {eventDetails?.title && (
                  <EventName>
                    {eventDetails.title}
                    {eventDetails?.category && (
                      <Category>
                        &nbsp;({typeLabels[eventDetails.category]})
                      </Category>
                    )}
                  </EventName>
                )}
              </Col>
              <Col span={10} style={{ display: 'flex', justifyContent: 'end' }}>
                {eventDetails?.status === 1 && (
                  <ButtonShowStudent
                    onClick={() => {
                      navigate(`/events/${eventDetails.id}`), onClose()
                    }}
                  >
                    Show Students
                  </ButtonShowStudent>
                )}
              </Col>
            </Row>

            {eventDetails?.startDate && eventDetails?.endDate && (
              <EventLabel>
                Event date & time
                <EventDatecard
                  borderColor={categoryStyle.borderColor}
                  backgroundColor={categoryStyle.backgroundColor}
                  color={categoryStyle.textColor}
                  hasTime={true}
                  style={{ marginTop: '2px' }}
                >
                  <EventData1>
                    {eventDetails.startDate?.split('T')[0] ===
                    eventDetails.endDate?.split('T')[0]
                      ? formatDateTime(eventDetails.startDate)
                      : `${formatDateTime(eventDetails.startDate)} ${' - '} 
                        ${formatDateTime(eventDetails.endDate)}`}
                  </EventData1>

                  {eventDetails?.startTime &&
                    eventDetails?.endTime &&
                    hasTime && (
                      <EventData1>
                        {formatTime(eventDetails.startTime)} -{' '}
                        {formatTime(eventDetails.endTime)}
                      </EventData1>
                    )}
                  {eventDetails?.allDayEvent && (
                    <EventData1>All Day</EventData1>
                  )}
                </EventDatecard>
              </EventLabel>
            )}
            {eventDetails?.eventMode === 'OFFLINE' &&
              eventDetails?.location?.[0]?.length > 0 && (
                <EventLabel>
                  Event Location
                  <EventData>{eventDetails.location}</EventData>
                </EventLabel>
              )}

            {eventDetails?.onlineLink && (
              <EventLabel>
                Event Link
                <EventData>
                  <a
                    href={
                      eventDetails.onlineLink.startsWith('http://') || 
                      eventDetails.onlineLink.startsWith('https://') 
                        ? eventDetails.onlineLink 
                        : `https://${eventDetails.onlineLink}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {eventDetails.onlineLink}
                  </a>
                </EventData>
              </EventLabel>
            )}
            <EventLabel>
              Event For
              <div>
                <Container1
                  expanded={expanded}
                  style={{
                    height:
                      contentHeight.current?.clientHeight > 250 && !expanded
                        ? '200px'
                        : 'auto',
                  }}
                >
                  <EventData4 ref={contentHeight}>{renderContent()}</EventData4>
                </Container1>

                {contentHeight.current?.clientHeight > 250 &&
                  (!expanded ? (
                    <ShowMoreText visible={!expanded} onClick={toggleExpanded}>
                      Show More...
                    </ShowMoreText>
                  ) : (
                    <ShowLessText visible={expanded} onClick={toggleExpanded}>
                      Show Less
                    </ShowLessText>
                  ))}
              </div>
            </EventLabel>
            {eventDetails?.registrationLink && (
              <EventLabel>
                Registration Link
                <EventData>
                  <a
                    href={
                      eventDetails.registrationLink.startsWith('http://') || 
                      eventDetails.registrationLink.startsWith('https://') 
                        ? eventDetails.registrationLink 
                        : `https://${eventDetails.registrationLink}`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      wordBreak: 'break-all',
                      overflowWrap: 'break-word',
                      whiteSpace: 'pre-wrap',
                    }}
                  >
                    {eventDetails.registrationLink}
                  </a>
                </EventData>
              </EventLabel>
            )}
            {eventDetails.isRegister && (
              <>
                {eventDetails?.registerStartDate &&
                  eventDetails?.registerEndDate && (
                    <EventLabel>
                      Registration Start & End Date
                      <EventData>
                        {eventDetails?.registerStartDate?.split('T')[0] ===
                        eventDetails?.registerEndDate?.split('T')[0]
                          ? formatDateTime(eventDetails.registerStartDate)
                          : `${formatDateTime(
                              eventDetails.registerStartDate
                            )} ${' - '} 
                        ${formatDateTime(eventDetails.registerEndDate)}`}
                      </EventData>
                      {eventDetails.registerEndTime && (
                        <EventData>
                          {formatTime(eventDetails.registerEndTime)}
                        </EventData>
                      )}
                    </EventLabel>
                  )}

                {eventDetails?.registerAmount > 0 && (
                  <EventLabel>
                    Registration Amount
                    <EventData>{eventDetails.registerAmount}</EventData>
                  </EventLabel>
                )}
              </>
            )}

            {eventDetails?.description && (
              <EventLabel>
                Event Description
                <EventData>
                  <div
                    style={{
                      whiteSpace: 'pre-wrap',
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: eventDetails.description,
                    }}
                  />
                </EventData>
              </EventLabel>
            )}

            {eventDetails?.pocName && eventDetails?.pocNumber && (
              <EventLabel>
                POC Details
                <EventData>
                  {eventDetails.pocName} - {eventDetails.pocNumber}
                </EventData>
              </EventLabel>
            )}

            {eventDetails?.speakers?.length > 0 && (
              <EventLabel>
                Speakers/Panellists
                {eventDetails.speakers
                  // .reduce((uniqueSpeakers, event) => {
                  //   if (
                  //     !uniqueSpeakers.find(
                  //       speaker => speaker.link === event.link
                  //     )
                  //   ) {
                  //     uniqueSpeakers.push(event)
                  //   }
                  //   return uniqueSpeakers
                  // }, [])
                  .map((event, index) => (
                    <EventData key={index + 'event'}>
                      {event.name} -{' '}
                      <a
                        href={
                          event.link.startsWith('http://') || 
                          event.link.startsWith('https://') 
                            ? event.link 
                            : `https://${event.link}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {event.link}
                      </a>
                    </EventData>
                  ))}
              </EventLabel>
            )}

            <div>
              {eventDetails.documents &&
                eventDetails.documents.map((doc, index) => (
                  <div key={index + 'document'}>
                    {' '}
                    {/* Use a unique identifier here */}
                    <Uploaders
                      borderColor={categoryStyle.borderColor}
                      onClick={() => downloadFileLocal(doc)}
                    >
                      <div style={{ marginTop: '4px' }}>
                        <PinIcon />
                      </div>
                      {truncateName(doc.name, 6)}
                      <Size>{convertBytesToKB(doc.size)} KB</Size>
                    </Uploaders>
                  </div>
                ))}
            </div>

            {!params?.['*']?.includes('newevent') && (
              <ButtonContainer>
                {eventDetails?.status != 0 && (
                  <>
                    <StyledButton1
                      onClick={handleDuplicateClick}
                      borderColor={categoryStyle.borderColor}
                      backgroundColor={categoryStyle.backgroundColor}
                      color={categoryStyle.textColor}
                    >
                      Duplicate
                    </StyledButton1>
                    <VerticalDivider borderColor={categoryStyle.borderColor} />
                  </>
                )}
                {!isEditing && (
                  <StyledButton1
                    onClick={() =>
                      navigate(`/events/editevent/${eventDetails.id}`)
                    }
                    borderColor={categoryStyle.borderColor}
                    backgroundColor={categoryStyle.backgroundColor}
                    color={categoryStyle.textColor}
                  >
                    Edit
                  </StyledButton1>
                )}
                <StyledButton2
                  onClick={handleDeleteClick}
                  borderColor={categoryStyle.borderColor}
                  backgroundColor={categoryStyle.backgroundColor}
                  color={categoryStyle.textColor}
                >
                  Delete
                </StyledButton2>
              </ButtonContainer>
            )}
          </StyledDivision>
        </MainDiv>
      </div>

      {isModalVisible && (
        <Modal onClose={handleCloseModal}>
          <ShortListModalImg>
            {modalContent.image === 'deleteImage' ? (
              <img src={objects} alt="DeleteState" />
            ) : modalContent.image === 'publishImage' ? (
              <img src={publish} alt="PublishState" />
            ) : modalContent.image === 'duplicateImage' ? (
              <img src={duplicate} alt="DuplicateState" />
            ) : (
              <div>No Image Found</div>
            )}
          </ShortListModalImg>
          <ModalText>{modalContent.text}</ModalText>
          {modalContent.actionType === 'duplicate' && (
            <ModalText1>
              The duplicated event will be saved in drafts
            </ModalText1>
          )}
          {modalContent.actionType === 'publish' && (
            <ModalCheckbox center>
              Send via
              <Checkbox style={{ padding: '10px' }}>WhatsApp</Checkbox>
              <Checkbox>Email</Checkbox>
            </ModalCheckbox>
          )}
          <ButtonDiv>
            {modalContent.actionType === 'delete' ||
            modalContent.actionType === 'duplicate' ? (
              <>
                <Button.Secondary
                  height={'38px'}
                  text={'No'}
                  onClick={handleCloseModal}
                />
                <Button.Primary
                  height={'38px'}
                  text={'Yes'}
                  onClick={handleConfirmAction}
                />
              </>
            ) : (
              <>
                <Button.Secondary
                  height={'38px'}
                  text={'Back'}
                  onClick={handleCloseModal}
                />
                <Button.Primary
                  height={'38px'}
                  text={'Send'}
                  loading={loading}
                  disabled={loading}
                  onClick={handleConfirmAction}
                />
              </>
            )}
          </ButtonDiv>
        </Modal>
      )}
      {isPublish && (
        <Right>
          <Button.Primary
            text={'Publish'}
            height="38px"
            width="97px"
            style={{ marginTop: '20px' }}
            onClick={handlePublishClick}
           
          />
        </Right>
      )}
    </>
  )
}
export default PreviewBox
